import { render, staticRenderFns } from "./RehabCoursesTabbar.vue?vue&type=template&id=35287b5c&scoped=true"
import script from "./RehabCoursesTabbar.vue?vue&type=script&lang=js"
export * from "./RehabCoursesTabbar.vue?vue&type=script&lang=js"
import style0 from "./RehabCoursesTabbar.vue?vue&type=style&index=0&id=35287b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35287b5c",
  null
  
)

export default component.exports